import React, { useState, useEffect } from 'react';
import {
  FormField,
  InlineAlert,
  Modal,
} from './ui';
import api from '../../services/api';

const AdminFormDialog = ({ open, onClose, admin, onSuccess }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    if (admin) {
      setFormData({
        first_name: admin.first_name || '',
        last_name: admin.last_name || '',
        username: admin.username || '',
        email: admin.email || '',
        password: '',
      });
    } else {
      setFormData({
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
      });
    }
  }, [open, admin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      const dataToSend = { ...formData };
      if (admin && !dataToSend.password) {
        delete dataToSend.password;
      }

      if (admin) {
        await api.put(`/admin/admins/${admin.id}`, dataToSend);
      } else {
        await api.post('/admin/admins', dataToSend);
      }

      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error saving admin:', err);
      setError(err.response?.data?.message || 'Error al guardar el administrador');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title={admin ? 'Editar administrador' : 'Agregar administrador'}
      onClose={submitting ? undefined : onClose}
      footer={
        <>
          <button type="button" className="btn-admin-secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </button>
          <button type="submit" form="admin-form" className="btn-admin" disabled={submitting}>
            {submitting ? 'Guardando…' : admin ? 'Guardar' : 'Crear'}
          </button>
        </>
      }
    >
      <form id="admin-form" className="space-y-4" onSubmit={handleSubmit}>
        {error && <InlineAlert tone="error">{error}</InlineAlert>}
        <FormField id="first_name" label="Nombre" value={formData.first_name} onChange={handleChange} required />
        <FormField id="last_name" label="Apellido" value={formData.last_name} onChange={handleChange} required />
        <FormField id="username" label="Usuario" value={formData.username} onChange={handleChange} required />
        <FormField id="email" label="Email" type="email" value={formData.email} onChange={handleChange} required />
        <div>
          <label htmlFor="password" className="field-label">
            {admin ? 'Contraseña (dejar vacío para no cambiar)' : 'Contraseña *'}
          </label>
          <div className="flex gap-2">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              className="field-input"
              value={formData.password}
              onChange={handleChange}
              required={!admin}
              autoComplete="new-password"
            />
            <button
              type="button"
              className="btn-admin-secondary shrink-0"
              onClick={() => setShowPassword((s) => !s)}
            >
              {showPassword ? 'Ocultar' : 'Ver'}
            </button>
          </div>
          <p className="mt-1 text-xs text-muted">
            {admin ? 'Dejar vacío si no deseas cambiar la contraseña' : 'Mínimo 6 caracteres'}
          </p>
        </div>
      </form>
    </Modal>
  );
};

export default AdminFormDialog;
